// extracted by mini-css-extract-plugin
module.exports = {"tile":"_8be8008","tileValue":"_6d16565","countdown":"_51245c3","lateReg":"_e882bdc","tileLabel":"_7bbfd1e"};